'use client';

import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import { Stack } from '@mui/system';

import { GameSettingsTable } from '../game-settings-table';

export function GameSettings({ game }: { game: any | undefined }): React.JSX.Element {
  //   const searchParams = useSearchParams();

  //   const [dto, setDto] = React.useState({
  //     title: game?.title[selectedLanguage] || '',
  //     description: game?.desc[selectedLanguage] || '',
  //     rtp: game?.rtp,
  //   });

  return (
    <Stack direction="column" gap={2}>
      <Card>
        <CardContent>
          <Stack direction="column" gap={1.5}>
            {game ? <GameSettingsTable gameData={{ ...game }} /> : null}
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}
